import React from 'react';
import * as S from "./style";

const FourthSection = () => {
  return (
    <S.Section>
      <S.Title>Educação</S.Title>
      <S.Content>
        <S.TitleContent>Curso de Web Full Stack na Labenu</S.TitleContent>
        <S.Text>
          6 meses - 2020
          <br /><br />
          Curso intensivo com 1000 horas de aprendizagem e projetos práticos em Front-End, Back-End e DevOps,
          cobrindo os seguintes tópicos, ferramentas e frameworks:
          <br /><br />
          Git e GitHub, HTML, CSS, JavaScript, React.js,
          Redux, Unit Testing, TypeScript, Node.js, Express, SOLID, Clean Architecture, SQL, MySQL, Firebase e AWS.
        </S.Text>
      </S.Content>
      <S.Content>
        <S.TitleContent>Graduação Tecnológica em Coding na Uninabuco</S.TitleContent>
        <S.Text>
          18 meses - 2020 até 2021.2
          <br /><br />
          Graduação com 1600 horas com foco no desenvolvimento de soluções para web, desktop e
          mobile dos mais variados tipos usando frameworks, plataformas e linguagens de programação, que vão desde
          sistemas simples até grandes e complexos.
          <br /><br />
          Tudo isso associado a utilização de metodologias de desenvolvimento de software e aliado a consciência
          humanística e de negócios, através do trabalho em equipe e habilidades como liderança, inovação e colaboração.
          </S.Text>
      </S.Content>
      <S.Content>
        <S.TitleContent>Graduação em Administração no Centro Universitário Tiradentes</S.TitleContent>
        <S.Text>
          4 anos - 2015 até 2018
          <br /><br />
          Por meio da graduação em administração adquiri conhecimento sobre os aspectos gerais do funcionamento 
          administrativo de organizações e também conhecimentos vitais, como finanças, logística, 
          gestão de marketing, estratégia empresarial, análise de investimentos e orçamento, gestão de pessoas, gestão da produção, 
          análise de dados, processos entre outros.
        </S.Text>
      </S.Content>
    </S.Section>
  )
}


export default FourthSection;
